import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {CommonService} from '../../common/controller/common.service';




import {ApiMessageService} from '../../core/api-message.service';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {ConfigService} from '../../core/config.service';
import {Table} from '../../common/model/table.model';
import {MODULE_CONFIGURAZIONE} from '../../app-routing.module';
import {TipoGerarchiaStruttura} from './tipogerarchiastruttura.model';

@Injectable()
export class TipoGerarchiaStrutturaService extends CommonService<TipoGerarchiaStruttura> {

  public static ROUTE = 'tipogerarchiastruttura';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): TipoGerarchiaStruttura {
    return JsonBaseBuilder.jsonToTipoGerarchiaStruttura(json);
  }

  public getModule(): string {
    return MODULE_CONFIGURAZIONE;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return TipoGerarchiaStrutturaService.ROUTE;
  }

  public getTable(items: TipoGerarchiaStruttura[]): Table {
    return Table.buildBaseTable(TipoGerarchiaStruttura.getTableKeys(), items);
  }

  public byTipoEntitaOrganizzativa(tipoEntitaOrganizzativaId: number): Observable<TipoGerarchiaStruttura[]> {
    return this.getAll({ 'tipoEntitaOrganizzativaId': tipoEntitaOrganizzativaId});
  }


}
